import { CapoPlugin } from "/root/workspace/ldshop_vest/node_modules/.pnpm/@unhead+vue@1.11.11_vue@3.5.12/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];